import { render } from "./BiometricVerification.vue?vue&type=template&id=203e1c2f&scoped=true"
import script from "./BiometricVerification.vue?vue&type=script&lang=js"
export * from "./BiometricVerification.vue?vue&type=script&lang=js"

import "./BiometricVerification.vue?vue&type=style&index=0&id=203e1c2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203e1c2f"]])

export default __exports__